import {l as v} from '@theme/theme-sections';
import '@theme/global';
import '@theme/details-modal';
import '@theme/product-modal';
import '@theme/component-product-recommendations';
import '@theme/product-recommendations-cart';
import '@theme/product-form';
import '@theme/product-card';
import {i as E} from '@theme/component-accordion';
import {i as w} from '@theme/component-tabs';
import {i as C} from '@theme/component-modal';
import {i as S} from '@theme/component-size-table';
import {i as y} from '@theme/component-variant-radios';
import {i as g} from '@theme/component-variant-select';
import {i as L} from '@theme/component-drag-scroll';
import '@theme/request-idle-callback';
import '@theme/combined-listings';
import '@theme/product-video';
import '@theme/card-image';
import '@theme/component-dynamic-modal-content';
document.addEventListener('DOMContentLoaded', () => {
  v('*'), E(), w(), C(), S(), y(), g(), L();
});
import('@theme/header-search-app')
  .then((n) => n.default())
  .catch((n) => window.console.error('Could not load App module', n));
